export const SET_USER = 'SET_USER';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_USER_ROLE_CHANGE_PENDING = 'SET_USER_ROLE_CHANGE_PENDING';

export const SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN';
export const SET_TOKEN_EXPIRED = 'SET_TOKEN_EXPIRED';
export const LOGOUT = 'LOGOUT';
